export default __webpack_public_path__ + "static/media/sac-river-colusa.566c8416.jpg";